<div class="modal-header">
    <h2 class="modal-title">Add Purchase Order</h2>
</div>
<div class="modal-body">
    <div class="flex-fill d-flex flex-column">
        <div class="card">
            <div class="card-body">
                <dx-form *ngIf="purchaseOrderLine" [formData]="purchaseOrderLine" validationGroup="mainValidationGroup" [colCount]="2">
                    <dxi-item [label]="{ text: 'Job' }" [colSpan]="2">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="purchaseOrderLine.jobId"
                                [items]="activeJobs"
                                valueExpr="id"
                                displayExpr="displayName"
                                searchEnabled="true"
                                [disabled]="isJobDisabled"
                            >
                            </dx-select-box>
                        </div>
                        <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="invoiceDate" [label]="{ text: 'Invoice Date' }">
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item [label]="{ text: 'Vendor' }" [colSpan]="2">
                        <div *dxTemplate>
                            <dx-autocomplete [(value)]="purchaseOrderLine.vendor" searchMode="startswith" [dataSource]="vendors"> </dx-autocomplete>
                        </div>
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="description" editorType="dxTextArea" [label]="{ text: 'Description' }" [editorOptions]="{ height: 125 }" [colSpan]="2"> </dxi-item>
                    <dxi-item dataField="amount" [label]="{ text: 'Amount' }" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" min=".01" message="Cannot be less than .01"> </dxi-validation-rule>
                    </dxi-item>
                    <!-- AFTER HERE -->
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item itemType="group" caption="Attachments" [colSpan]="2" [colCount]="1"  *ngIf="purchaseOrderLine.id > 0">
                        <dxi-item>
                            <ul style="list-style-type: none; padding-inline-start: 0px">
                                <li *ngFor="let attachment of purchaseOrderLineAttachments">
                                    <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                    <a title="view" style="font-size: x-large; font-weight: bold; color: cornflowerblue" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                </li>
                            </ul>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate>
                                <dx-file-uploader
                                    name="fileUpload"
                                    selectButtonText="Select File(s)"
                                    class="attachments"
                                    accept="*"
                                    uploadMode="instantly"
                                    [showFileList]="false"
                                    multiple="true"
                                    [uploadUrl]="uploadUrl"
                                    (onUploadStarted)="uploadStarted($event)"
                                    (onUploadError)="uploadError($event)"
                                    (onUploaded)="uploaded($event)"
                                >
                                </dx-file-uploader>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <!-- BEFORE HERE -->
                </dx-form>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-success" (click)="save(true)">Save & Close</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
</div>
